import styled, { css } from 'styled-components';
import Text from '@components/text';
import LinkComponent from '@components/link';

export const Container = styled.div<{ $enclosedContainer?: boolean }>`
  ${({ theme }) => css`
    margin: 0 auto;
    padding: 3.5rem 3rem;
    display: flex;
    justify-content: center;
    background-color: ${theme.colors.primaryLight};
    border-radius: ${theme.borderRadius.large};

    @media (max-width: ${theme.breakpoints.lg}) {
      padding: ${theme.padding.cards.md};
    }

    @media (max-width: ${theme.breakpoints.md}) {
      padding: ${theme.padding.cards.sm};
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: ${theme.padding.cards.sm} 1rem;
      border-radius: calc(${theme.borderRadius.large} / 2);
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    max-width: 1056px;

    @media (max-width: ${theme.breakpoints.xxl}) {
      max-width: 1026px;
    }

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      max-width: 960px;
    }

    @media (max-width: ${theme.breakpoints.lg}) {
      max-width: 720px;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      max-width: 540px;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
      text-align: left;
      max-width: 100%;
    }
  `}
`;

export const LinkButton = styled(LinkComponent)`
  ${({ theme }) => css`
    margin: 1rem 0 auto;
    background-color: ${theme.colors.white};
    color: ${theme.colors.black};
    transition: transform 0.3s ease-in-out;

    &:hover {
      transform: scale(1.0625);
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
    }
    &:active {
      transform: scale(0.9375);
    }
  `}
`;

export const StyledText = styled(Text)`
  ${({ theme }) => css`
    display: block;
    margin-bottom: ${theme.spacing.md};
  `}
`;
